module.exports = __webpack_public_path__ + "img/acceptButtonImage.4cb2bbdd.png";